// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__hMYg-","title":"Navbar_title__wuNwf"};